module.exports = ".login-card {\n    width:300px;\n    margin: 100px auto 0 auto;\n}\n\n.login-card-header {\n    margin: 0;\n    padding: 0;\n}\n\n.logo {\n    width: 316px;\n    padding: 0 16px;\n}\n\n.login-card-body {\n    margin-top: 20px;\n}\n\n.login-button {\n    background:#0C3865; \n    color:white;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/login.css
// module id = ./src/app/components/login/login.css
// module chunks = main